
import { partInfoHelper } from "@/components/mixins";
import CurrencyText from "@/components/Elements/CurrencyText.vue";
import { 
    DnFunctionButton 
  }       from "@/components/Elements"
  import PartCardItem from "./PartCardItem.vue"
  import SkeletonLoader from "@/components/Elements/SkeletonLoader.vue"

export default {
  name: "PartCard",
  components: {
    CurrencyText,
    DnFunctionButton,
    PartCardItem,
    SkeletonLoader
  },
  props: {
    parts: {
      type: Array,
      required: true,
    },
    partImageOverrides: {
      type: Array,
      required: false,
    },
    resultsCount: {
      type: Number,
      required: true,
    },

    crossParts: {
      type: Array,
      required: true,
    },
    crossPartImageOverrides: {
      type: Array,
      required: false,
    },
    crossResultsCount: {
      type: Number,
      required: true,
    },
    loadingResults:{
      type: Boolean,
      required: true,
    }
  },
  mixins: [partInfoHelper],
  methods: {
    emitShowPartResults() {
      this.$emit("show-part-results", true);
    },
    emitShowCrossResults() {
      this.$emit("show-cross-results");
    },
  },
};